import { Outlet, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import {
  AtsJobApplicatioNotesDocument,
  AtsJobApplicationNotesFeedbacksFragment,
} from 'generated/resources/graphql'
import { range } from 'lodash'

import { useQuery } from 'modules/core/hooks/useQuery'

import { FeedbackSkeletonDisplay } from 'modules/ats/components/Feedbacks/Feedback/FeedbackSkeletonDisplay'

import { ApplicationFeedbacks } from './ApplicationFeedbacks'

interface OutletContext {
  application: AtsJobApplicationNotesFeedbacksFragment
  isReviewerRole: boolean
}

const JobApplicationNotesPage = () => {
  const { application, isReviewerRole } = useOutletContext<OutletContext>()

  const { data, loading } = useQuery(AtsJobApplicatioNotesDocument, {
    variables: {
      candidateId: application.candidate.id,
      jobPostingId: application.jobPosting.id,
      publicFeedbacks: isReviewerRole,
    },
  })

  const feedbacks = data?.ats?.feedbacksConnection?.nodes || []
  const evaluationFormsData = data?.ats?.evaluationFormsConnection?.nodes || []
  const evaluationForms = isReviewerRole ? [] : evaluationFormsData

  return (
    <>
      {loading ? (
        <Box gap="s32">
          {range(3).map((skeletonRange) => (
            <FeedbackSkeletonDisplay key={skeletonRange} />
          ))}
        </Box>
      ) : (
        <ApplicationFeedbacks
          application={application}
          feedbacks={feedbacks}
          evaluationForms={evaluationForms}
        />
      )}

      <Outlet context={{ application }} />
    </>
  )
}

export default JobApplicationNotesPage
